export const SIDE_TYPE = {
    /**
     * 地面
     */
    ground: "ground",
    road_network: "road-network",
    road: "road",

    axis_net: "axis-net",
    fence: "fence",
    hole: "hole",
    /**
     * 楼板
     */
    floor: "floor",
    /**
     * 楼板
     */
    ceiling: "ceiling",
    wall: "wall",

    column: "column",


    elevator_car: "elevator-car",
    door: "door",
    window: "window",

    texture: "texture",
    room: "room",
    fire_control_room: "fire_control_room",
    pump_room: "pump_room",
    elevator: "elevator",

    parking_space: "parking-space",

    no_motor_parking_space: "no-motor-parking-space",
    smoke_detector: "smoke-detector",
    fire_extinguisher: "fire-extinguisher",
    fire_hydrant: "fire-hydrant",
    spray_head: "spray-head",

    /**
     * 楼层
     */
    storey: "storey",
    /**
     * 巡更点
     */
    patrol_point: "patrol-point",

    tree: "tree-shrubs",

    street_lamp: "street_lamp",
    monitor: "monitor",
    component: "component",

    // 结构
    joint_block: "joint-block", // 节点
    section: "section", // 截面
    material: "material", // 材料
    structure_column: "structure-column", // 柱
    structure_beam: "structure-beam", // 梁
    structure_bar: "structure-bar", // 杆
    structure_wall: "structure-wall", // 墙
    structure_floor: "structure-floor", // 板
    structure_brace: "structure-brace", // 支撑
    component_assemble: "component-assemble", // 布置构件


    // 暖通
    tunnel_block: "tunnel-block",  // 管道
    attachment_block: "attachment-block",  // 配件
    connect_block: "connect-block",  // 接头
    device_block: "device-block",  // 设备
    hvac_assemble: "hvac-assemble",  // 暖通布置


    station: "station",
    roof_slab: "roof-slab",
    eaves_board: "eaves-board",
    gutter: "gutter",
    // 消防管道
    fire_tunnel_block: "fire-tunnel-block",
    fire_shutter: "fire_shutter", // 防火卷帘
    smoke_tunnel_block: "smoke_tunnel_block", //排烟送风管道

    camera: "camera",
    anemoclinograph: "anemoclinograph",
    water_level_gauge: "water-level-gauge",
    dvr: "dvr",
    serial_device: "serial-device",
    cable: "cable",
    model: "model",
    roam_route: "roam-route",

    backup: "backup",   // 备份
    group: "group", // 组

    permission: "permission", // 权限

    render_data: "render-data",
    escape_route: "escape_route",
    elevator_group: "elevator_group",
    obj_loader: "obj-loader",
}